import React from "react"

const Question = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0ZM7.2 8C7.2 7.55817 7.55817 7.2 8 7.2C8.53638 7.2 8.94876 7.10602 9.20624 6.93436C9.40647 6.80087 9.6 6.56696 9.6 6C9.6 5.50579 9.43071 5.19779 9.22255 5.00328C9.00096 4.79621 8.67842 4.66655 8.31195 4.6491C7.54632 4.61264 6.90432 5.04032 6.78912 5.73152C6.71648 6.16734 6.3043 6.46175 5.86848 6.38912C5.43266 6.31648 5.13825 5.9043 5.21088 5.46848C5.49568 3.75968 7.05368 2.98737 8.38805 3.05091C9.07158 3.08346 9.77404 3.32879 10.3149 3.83423C10.8693 4.35222 11.2 5.09421 11.2 6C11.2 7.03305 10.7935 7.79913 10.0938 8.26564C9.69674 8.53032 9.24433 8.67193 8.8 8.7415V8.8C8.8 9.24183 8.44183 9.6 8 9.6C7.55817 9.6 7.2 9.24183 7.2 8.8V8ZM6.8 11.6C6.8 10.9373 7.33726 10.4 8 10.4C8.66274 10.4 9.2 10.9373 9.2 11.6C9.2 12.2627 8.66274 12.8 8 12.8C7.33726 12.8 6.8 12.2627 6.8 11.6Z"
      fill="#94A4B7"
    />
  </svg>
)

export default Question
